export default "__VITE_ASSET__B8$tmyZ3__"